export const translatedData = {
  '270019c4-4a80-483a-b701-757d4f7956a2:children': {
    '@@makeswift/type': 'prop-controllers::text-input::v1',
    value: 'Comprar ahora',
  },
  '2d5509fc-ef28-44c2-a52d-11278d893e45:text': {
    '0': 'StyleMatch',
  },
  '4e25b048-88c4-4e2a-b74f-2161f2567ac3:text': {
    '0': '¿Por qué comprar con nosotros?',
  },
  '5350c1a7-0cfb-48ba-94b3-43014b3a01f9:text': {
    '0': 'Acceso anticipado DropAlert',
  },
  '6b191363-f9c8-4988-9739-f74ca9cf7cee:text': {
    '0': 'GRAN Oferta de Verano',
  },
  '7581e32e-b699-4d95-80c5-af532cbeef1d:text': {
    '0': 'En nuestra tienda, la moda se encuentra con la innovación para crear una experiencia de compra como ninguna otra. Desde nuestro Estudio de Prueba Virtual que te permite previsualizar outfits con precisión, hasta StyleMatch que cura looks personalizados solo para ti, hacemos que encontrar tu ajuste perfecto sea fácil y divertido. Nuestra Garantía de Ajuste+ asegura que cada pieza se sienta como si hubiera sido hecha para ti, mientras que la App Compañero de Closet te ayuda a construir y estilizar un guardarropa que amarás. Además, con nuestro Filtro EcoEdit, puedes comprar de manera sostenible sin comprometer el estilo. Y con el Acceso Anticipado DropAlert, siempre estarás un paso adelante de las tendencias. No es solo comprar—es estilizar de manera inteligente.',
  },
  '89ad1aad-73f7-4e99-962f-ebf7e05a6810:text': {
    '0': 'Construye tu guardarropa de ensueño digitalmente. Nuestra App Compañero de Closet mantiene registro de lo que posees, te ayuda a estilizar nuevos outfits, y sugiere qué comprar después para completar tu look.',
  },
  '988e445b-cc28-46e0-b43d-eab4ed868f1a:text': {
    '0': 'Sé el primero en la fila para los lanzamientos más populares. Con DropAlert™, obtienes acceso exclusivo anticipado a colecciones limitadas, alertas de restock, y estilos solo para VIP—antes que nadie más.',
  },
  '9a55c845-b91b-4e65-a9bf-7647dff14836:text': {
    '0': 'App Compañero de Closet',
  },
  'a80a02b2-0b2a-4719-8aff-7674f894e182:text': {
    '0': 'Estudio de Prueba Virtual',
  },
  'aa3bb52a-350b-4bc3-9e80-aa6046f23472:altText': {
    '@@makeswift/type': 'prop-controllers::text-input::v1',
    value: 'Cielo nocturno',
  },
  'bd59d14c-7d98-463f-8d8d-46ef53a765b5:text': {
    '0': 'La moda se encuentra con la sostenibilidad. Compra sin culpa filtrando nuestra colección por piezas hechas éticamente, recicladas, o de bajo impacto—porque lucir bien también debería sentirse bien.',
  },
  'c712307f-4605-4204-9c30-f325c5861170:text': {
    '0': 'Descubre tu look perfecto en segundos. StyleMatch recomienda piezas basadas en tu gusto, compras pasadas, e incluso tu estado de ánimo. Es como tener un estilista personal en tu bolsillo.',
  },
  'cec3c603-3401-4b1b-8e2f-00d984f4ba71:text': {
    '0': 'Nunca te preocupes por la talla incorrecta otra vez. Garantía de Ajuste+ usa tallaje basado en datos más intercambios gratuitos para asegurar que cada pieza te quede perfectamente—o lo arreglaremos, sin preguntas.',
  },
  'dc706501-3b06-403c-929d-34048393d8f9:text': {
    '0': 'Filtro EcoEdit',
  },
  'e4c44cbd-8e06-4281-9a5a-a9c67998df1a:text': {
    '0': 'Míralo. Estilízalo. Ámalo. Nuestro Estudio de Prueba Virtual te permite previsualizar outfits en un modelo 3D que coincide con tu tipo de cuerpo—para que puedas comprar con confianza y saltarte el drama del probador.',
  },
  'ef06e719-b526-4fd7-95f7-324a0393df43:text': {
    '0': 'Garantía de Ajuste+',
  },
}
